import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DecisionService {
  httpOptions:any;
  headers:any;
  private _refreshNeeded$ = new Subject<void>();
  get refreshNeeded$() {
    return this._refreshNeeded$;
  }
  constructor(private http:HttpClient) 
  {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'my-auth-token'
      })
    };
  }

  updateDecision(url,param){
    return this.http.put(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
}
